module.exports = __webpack_public_path__ + "img/manajemen_kepegawaian_pengajuan_pindah.cd70885c.svg";